import {ModalProvider} from "./components/ModalProvider";
import {BrowserRouter as Router, Route, Routes} from "react-router-dom";
import ErrorBoundaryWithRouter from "./components/error/ErrorBoundary";
import ErrorPage from "./components/error/ErrorPage";
import NotFound from "./components/NotFound";
import EmptyPage from "./components/EmptyPage";
import ScrollToTop from "./services/ScrollToTop";

import Header from "./components/Header";
import Footer from "./components/Footer";
import Main from "./pages/main/Main";


import PersonChoice from "./pages/search/person/PersonChoice";
import PersonIdList from "./pages/search/person/PersonIdList";
import PersonSearch from "./pages/search/person/PersonSearch";

import SchoolSearch from "./pages/search/school/SchoolSearch";
import SchoolIdList from "./pages/search/school/SchoolIdList";

import BiographyAbout from "./pages/search/biography/BiographyAbout";
import BiographyList from "./pages/search/biography/BiographyList";

import About from "./pages/about/About";

import Archive from "./pages/archive/Archive";
import Redbook from "./pages/archive/redbook/Redbook";
import RedbookId from "./pages/archive/redbook/RedbookId";
import ColonicalSchool from "./pages/archive/colonicalschool/ColonicalSchool";
import MiddleSchool from "./pages/archive/middleschool/MiddleSchool";
import GwanboPersonnel from "./pages/archive/gwanboPersonnel/GwanboPersonnel";
import DoboPersonnel from './pages/archive/doboPersonnel/DoboPersonnel'
import Alumni from "./pages/archive/alumni/Alumni";
import Album from "./pages/archive/album/Album";
import SchoolChoice from "./pages/search/school/SchoolChoice";
import SchoolCatalogue from "./pages/archive/schoolCatalogue/SchoolCatalogue";
import Biography from "./pages/archive/biography/Biography";
import BiographyCopy from "./pages/archive/biography/BiographyCopy";
import BiographyMain from "./pages/archive/biography/BiographyMain";
import BiographyId from "./pages/archive/biography/BiographyId";

// 이곳에는 샘플만 위차하도록 할것.
// import SampleAxios from "./pages/sample/Axios";
// import SampleTocs from "./pages/sample/Tocs";
// import SampleHanja from "./pages/sample/Hanja";
// import SampleArchive from "./pages/sample/Archive";
// import GwanboPersonnelSample from "./pages/sample/GwanboPersonnelSample";
// import Intersection from "./pages/sample/Intersection";
// import ErrorBoundary from "./pages/sample/ErrorBoundary";
// import SampleModal from './pages/sample/Modal'
// import FixedSizeList from './pages/sample/FixedSizeList';
// import BiographySample from "./pages/sample/BiographySample";
import MiddleSchoolBookId from "./pages/archive/middleschool/MiddleSchoolBookId";

function App() {
    return (
        <div className="App">
            <Router>
                <ScrollToTop />
                {/*TODO 아래 주석은 웹 접근성 */}
                {/*<div id="skipNav"><a href="#contents"*/}
                {/*                     onClick="document.getElementById('contents').tabIndex = -1;document.getElementById('contents').focus();return false;">본문*/}
                {/*    바로가기</a></div>*/}
                <div id="container">
                    <ErrorBoundaryWithRouter>
                        <Header/>
                        <ModalProvider>
                            <Routes>
                                {/*메인*/}
                                <Route path="/" element={<Main/>}/>

                                {/*소개*/}
                                <Route path="/about" element={<About/>}/>
                                {/* 주체(인물) 검색*/}
                                <Route path="/person_search" element={<PersonSearch/>}/>
                                <Route path="/person_search/:personName" element={<PersonChoice/>}/>
                                <Route path="/person/:person_id_list" element={<PersonIdList/>}/>

                                {/* 공간(학교) 검색*/}
                                <Route path="/school_search" element={<SchoolSearch/>}/>
                                <Route path="/school_search/:schoolName" element={<SchoolChoice/>}/>
                                <Route path="/school/:school_id_list" element={<SchoolIdList/>}/>

                                {/* 경험(회고록) */}
                                <Route path="/biography_about" element={<BiographyAbout/>}/>
                                <Route path="/biography_list" element={<BiographyAbout/>}/>
                                <Route path="/biography_list/" element={<BiographyAbout/>}/>
                                <Route path="/biography_list/:event_id" element={<BiographyList/>}/>

                                {/*아카이브*/}
                                <Route path="/archive" element={<Archive/>}/>
                                <Route path="/archive/redbook" element={<Redbook/>}/>
                                <Route path="/archive/redbook/:book_id" element={<RedbookId/>}/>
                                <Route path="/archive/colonial_school" element={<ColonicalSchool/>}/>
                                <Route path="/archive/middle_school" element={<MiddleSchool/>}/>

                                {/* TODO 추후 동경 교과서 협회 작업 시 사용할 것*/}
                                <Route path="/archive/middle_school/:book_id" element={<MiddleSchoolBookId/>}/>

                                <Route path="/archive/gwanbo_personnel" element={<GwanboPersonnel/>}/>
                                <Route path="/archive/dobo_personnel" element={<DoboPersonnel/>}/>
                                <Route path="/archive/alumni" element={<Alumni/>}/>
                                <Route path="/archive/school_catalogue" element={<SchoolCatalogue/>}/>
                                <Route path="/archive/biography" element={<BiographyMain/>}/>
                                <Route path="/archive/biography/search" element={<Biography/>}/>
                                <Route path="/archive/biography/copy" element={<BiographyCopy/>}/>
                                <Route path="/archive/biography/:book_id" element={<BiographyId/>}/>
                                <Route path="/archive/album" element={<Album/>}/>

                                {/*준비 중 페이지*/}
                                <Route path="/emptyPage" element={<EmptyPage/>}/>

                                <Route path="/error" element={<ErrorPage/>}/>
                                <Route path="/*" element={<NotFound/>}/>
                            </Routes>
                        </ModalProvider>
                        <Footer/>
                    </ErrorBoundaryWithRouter>
                </div>
            </Router>
        </div>
    );
}

export default App;
